import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { DECISION } from 'business/constants';
import type { UserInfoWithIdT } from 'business/definitions';
import type { ModuleT } from 'business/types';
import { useParams } from 'react-router';
import { RQAPICallWithData } from 'store/APIClient';

import { SUGGESTED_USERS_QUERY_KEY } from './constants/queryKeys';

/**
 * Hook React Query to fetch the list of suggested users for a given module
 * @param {ModuleT} module - The module for which the suggested users are fetched
 */
export const useGetSuggestedUsers = (
    module: ModuleT,
    enabled: boolean = true,
    allUsers: boolean = false,
    addSupport?: boolean,
): UseQueryResult<UserInfoWithIdT[]> => {
    const { slug } = useParams<{ slug: string }>();

    return useQuery({
        queryKey: [
            SUGGESTED_USERS_QUERY_KEY,
            module,
            slug,
            allUsers,
            addSupport,
        ],

        queryFn: async () => {
            const params = new URLSearchParams();
            if (module === DECISION && slug) {
                params.append('dashboard_slug', slug);
            }
            params.append('all_users', String(allUsers));
            if (addSupport !== undefined) {
                params.append('add_support', String(addSupport));
            }
            const endpoint = `auth/suggested_users/${module}?${params.toString()}`;
            const response = await RQAPICallWithData<UserInfoWithIdT>({
                endpoint,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled,
    });
};
